import { isClassDefinition } from '../../parser/utils/classUtils.js';
import { ObjectField } from '../../parser/models/objectField.js';
import { PreProcessContext } from '../models/preProcessContext.js';
import { processChildObjectFields } from './preProcessUtils.js';
import { processClassDef } from './processClassDef.js';

/**
 * Processor for handling default exports. It can delegate to class definition processing
 * or recurse into object properties.
 * 
 * @param field - The object field containing the default export.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as a default export.
 */
export function processDefaultExport(field: ObjectField, index: number, context: PreProcessContext): boolean {
  const isDefaultExport = field.isDefaultExport;

  if (isDefaultExport) {

    const { name, value } = field;

    if (isClassDefinition(value)) {
      return processClassDef(
        new ObjectField(field.groupName, name, value),
        index,
        context
      );
    }

    // process children
    const testProps = processChildObjectFields(
      field.groupName,
      value,
      context.options
    );

    context.tests.push(
      ...testProps
    );

    return true;
  }

  return false;
}
